export const isNotEmptyObject = (value: any[]) => Object.keys(value).length > 0
export const isNotDefaultObject = (value: any) => value !== "-1" && value !== -1
